import {
	CheckboxField,
	EntityDrawerProps,
	FCC,
	FormDrawer,
	FormDrawerContent,
	SingleSelectField,
	TextField,
} from "@dgs/core";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ALL_CONTACT_PHONE, ContactPhoneFormState } from "../../shared/types/contactPhone";

export const ContactPhoneDrawer: FCC<EntityDrawerProps<ContactPhoneFormState>> = ({ children, ...props }) => {
	const { t } = useTranslation();

	const validate = useCallback(
		(values: ContactPhoneFormState) => {
			const errors: { [K in keyof ContactPhoneFormState]?: any } = {};

			if (!values.phoneNumber) {
				errors.phoneNumber = t("Required field");
			}

			return errors;
		},
		[t],
	);

	return (
		<FormDrawer
			{...props}
			validate={validate}
			renderForm={(props) => (
				<FormDrawerContent {...props}>
					<TextField name="phoneNumber" label={t("Phone number")} type="tel" required />
					<SingleSelectField
						options={ALL_CONTACT_PHONE.map((e) => ({ label: t(e), value: e }))}
						getLabel={(x) => x.label}
						getValue={(x) => x.value}
						name="type"
						label={t("Type")}
						clearable={false}
					/>
					<CheckboxField label={t("Mark as primary")} name="isPrimary" />
					{children}
				</FormDrawerContent>
			)}
		/>
	);
};
